import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavigationEnd, Router } from '@angular/router';

import { getIsAuthenticated } from './store/selectors/user.selector';
import { UserState } from './store/models/user.model';
import { WebSocketService } from './store/services/web-socket.service';
import { MobileService } from './store/services/mobile.service';
import { init } from './store/actions/user.action';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isUserAuthenticated: boolean;
  mobileInterval: any;

  constructor(
    private store: Store<UserState>,
    private router: Router,
    private readonly wsService: WebSocketService,
    private readonly mobileService: MobileService,
  ) {
    this.store
      .select(getIsAuthenticated)
      .subscribe(
        (isAuthenticated: boolean) =>
          (this.isUserAuthenticated = isAuthenticated),
      );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.mobileService.set(event.target.innerWidth <= 599.98);
  }

  ngOnInit() {
    this.mobileService.set(window.innerWidth < 599.98);
    const dataParam = new URLSearchParams(window.location.search);
    if (dataParam.has('data')) {
      const skipTokenRemoval = localStorage.getItem('skipTokenRemoval');
      if (!skipTokenRemoval && skipTokenRemoval !== 'true') {
        localStorage.removeItem('token');
      }
      localStorage.removeItem('skipTokenRemoval');
    }
    this.store.dispatch(init());
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.mobileInterval = setInterval(() => {
      this.mobileService.set(window.innerWidth <= 599.98);
    }, 1000);
  }

  ngOnDestroy() {
    this.wsService.close();
    clearInterval(this.mobileInterval);
  }
}
